// extracted by mini-css-extract-plugin
module.exports = {"quizQuestion__title":"QuizQuestion_quizQuestion__title__20Rec","error":"QuizQuestion_error__2D5AB"};